<template>
    <div v-show="display" class="alart-msg" :class="{error: styleType == 'error'}">
        <img v-if="styleType == 'success'" class="tick" src="@/assets/img/icon/alarm_msg_blue.svg" alt="">
        <img v-if="styleType == 'error'" class="tick" src="@/assets/img/icon/alarm_msg_error.svg" alt="">
        <div class="content">
            <slot name="title"></slot>
            <slot name="description"></slot>
        </div>
        <img v-if="closeBtn" @click="alartClose" class="cancel" src="@/assets/img/icon/cancle_gray_large.svg" alt="">
    </div>
</template>
<script>
export default {
    data () {
        return {
            openStatus: this.display,   
        }
    },
    props: {
        display: Boolean,
        styleType: String,
        closeBtn: {
            type: Boolean,
            default: false,
        },
        count: {
            type: Number,
            default: 3000,
        },
    },
    watch: {
        display: {
            handler: function (val) {
                this.openStatus = val

                if(this.closeBtn == false){
                    this.showTip()
                }
            },
            immediate: true
        }
    },    
    methods: {
        alartClose: function () {
            this.$emit('alartStatus', false);
        },
        showTip: function () {
            var _self = this;
            setTimeout(function() {
                _self.$emit('alartStatus', false);
            }, _self.count); 
        }
    }
}
</script>
<style lang="scss"  >
    .alart-msg{
        position: fixed;
        padding: 24px 0;
        width: 600px;
        top: 100px;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        align-items: center;
        border-radius: 4px;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1), inset 4px 0 0 0 #71aae5;
        background-color: #ffffff;
        z-index: 999;
        .tick{
            width: 24px;
            margin-left: 35px;
            margin-right: 20px;
        }
        .content{
            span{
                display: block;
            }
            .title{
                font-size: 20px;
                font-weight: 500;
                color: #71aae5;
                margin-bottom: 6px;
            }
            .description{
                color: #525956;
            }
        }
        .cancel{
            position: absolute;
            right: 20px;
            cursor: pointer;
        }
    }
    .alart-msg.error{
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1), inset 4px 0 0 0 #fc7171;
        .content{
            .title{
                color: #fc7171;
            }
        }

    }
</style>


// WEBPACK FOOTER //
// src/components/widge/AlartMsg.vue